const sections = [
  {
    title: "1. Responsable del tratamiento",
    content: [
      "Dentista Contralor es responsable del tratamiento de los datos personales recopilados a través de este sitio y de la aplicación móvil relacionada con sus servicios de contraloría dental.",
      "Para consultas sobre privacidad o tratamiento de datos, puedes escribir a dentistacontralor@gmail.com.",
    ],
  },
  {
    title: "2. Datos que podemos recopilar",
    content: [
      "Datos de identificación y contacto, como nombre, correo electrónico, teléfono e identificadores de usuario.",
      "Datos operativos asociados a solicitudes, presupuestos, revisiones, documentos y archivos adjuntos ingresados por el usuario.",
      "Información técnica del dispositivo y de uso, como versión de la aplicación, sistema operativo, eventos de funcionamiento y token de notificaciones cuando corresponda.",
      "Información contenida en imágenes, documentos o respaldos que el usuario decida adjuntar voluntariamente.",
    ],
  },
  {
    title: "3. Uso de permisos del dispositivo",
    content: [
      "Camara: se utiliza únicamente cuando el usuario decide capturar fotografías para adjuntarlas a solicitudes, presupuestos o documentación relacionada.",
      "Archivos e imágenes: se utilizan para seleccionar y adjuntar documentos o respaldos desde el dispositivo.",
      "Biometría: se utiliza solo para facilitar el acceso seguro en el mismo dispositivo cuando el usuario habilita esta función.",
      "Notificaciones: se utilizan para informar eventos relevantes del flujo operativo de la aplicación, cuando esta funcionalidad está habilitada.",
    ],
  },
  {
    title: "4. Finalidad del tratamiento",
    content: [
      "Gestionar el acceso autenticado a la plataforma y a la aplicación móvil.",
      "Administrar solicitudes, presupuestos, revisiones y documentación asociada al servicio de contraloría dental.",
      "Mejorar la seguridad, continuidad operativa y experiencia de uso.",
      "Atender consultas, soporte y comunicaciones relacionadas con el servicio.",
    ],
  },
  {
    title: "5. Base de seguridad",
    content: [
      "La aplicación utiliza mecanismos de almacenamiento seguro provistos por el sistema operativo del dispositivo para proteger información sensible de sesión.",
      "No se utilizan mecanismos inseguros para almacenar credenciales cuando la plataforma dispone de opciones seguras.",
    ],
  },
  {
    title: "6. Compartición de datos",
    content: [
      "Los datos podrán ser compartidos únicamente con proveedores tecnológicos o servicios necesarios para la operación de la plataforma, envío de notificaciones, almacenamiento o soporte técnico.",
      "También podrán comunicarse cuando exista obligación legal, requerimiento de autoridad competente o necesidad operativa ligada a la prestación del servicio.",
      "Dentista Contralor no vende datos personales a terceros.",
    ],
  },
  {
    title: "7. Conservación de la información",
    content: [
      "Los datos serán conservados durante el tiempo necesario para cumplir con las finalidades descritas en esta política, obligaciones legales aplicables y requerimientos operativos del servicio.",
    ],
  },
  {
    title: "8. Derechos de los usuarios",
    content: [
      "El titular de los datos podrá solicitar acceso, rectificación, actualización o eliminación de su información cuando resulte procedente conforme a la normativa aplicable.",
      "Para ejercer estos derechos, puedes escribir a dentistacontralor@gmail.com.",
    ],
  },
  {
    title: "9. Seguridad de la información",
    content: [
      "Se adoptan medidas técnicas y organizativas razonables para proteger los datos personales frente a accesos no autorizados, pérdida, uso indebido, alteración o divulgación no autorizada.",
    ],
  },
  {
    title: "10. Cambios a esta política",
    content: [
      "Esta Política de Privacidad puede ser actualizada para reflejar cambios técnicos, operativos o legales. La versión vigente será la publicada en esta página.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <section className="px-6 md:px-8 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="card p-6 md:p-8 shadow-sm">
          <div className="section-tag">Información Legal</div>
          <h1 className="section-title text-2xl md:text-3xl mb-3">Política de Privacidad</h1>
          <p className="text-sm text-gray-500 mb-8">Última actualización: 10 de abril de 2026</p>

          <div className="space-y-8">
            <div className="rounded-2xl border border-codelco/15 bg-codelco/5 p-5">
              <p className="text-sm leading-7 text-gray-700">
                En Dentista Contralor respetamos la privacidad de nuestros usuarios y nos
                comprometemos a proteger los datos personales tratados a través de este sitio,
                de nuestra plataforma y de la aplicación móvil asociada.
              </p>
            </div>

            {sections.map((section) => (
              <section key={section.title}>
                <h2 className="text-lg font-semibold text-navy-600 mb-3">{section.title}</h2>
                <div className="space-y-3">
                  {section.content.map((paragraph) => (
                    <p key={paragraph} className="text-sm leading-7 text-gray-600">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}

            <section className="rounded-2xl border border-gray-200 bg-gray-50 p-5">
              <h2 className="text-lg font-semibold text-navy-600 mb-3">11. Contacto</h2>
              <div className="space-y-2 text-sm text-gray-600">
                <p>
                  Correo:{" "}
                  <a href="mailto:dentistacontralor@gmail.com" className="text-codelco hover:underline">
                    dentistacontralor@gmail.com
                  </a>
                </p>
                <p>
                  Teléfono:{" "}
                  <a href="tel:722226550" className="text-codelco hover:underline">
                    72 2 226550
                  </a>
                </p>
                <p>Dirección referencial: Av. Miguel Ramírez #140, Rancagua, Chile.</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
}
